export default function InvoiceView() {
    const yo = 'yo';

    return <>{yo}</>;
}
